import React from 'react';
import RenderIf from "@/components/render-if";
import {useApiMainInfo} from "@/api/mainInfo";
import {Globe, MapPin, Phone} from 'lucide-react';


function AuthSocialNetworkSection(props) {
    const {data: info, isPending} = useApiMainInfo()
    // const info = useMemo(() => {
    //     if (mainInfo) {
    //         return mainInfo;
    //     }
    //     return {}
    // }, [myAcademySlug(), mainInfo]);

    if (isPending) {
        return null
    }


    return (
        <div>

            <div className="m-2 mt-8">

                <div className=" flex flex-wrap gap-2 justify-center items-center max-w-md">
                    <RenderIf condition={info?.data?.social_networks?.facebook}>
                        <div>
                            <a href={info?.data?.social_networks?.facebook} target="_blank"
                               className="social-icon facebook"
                               title='فیسبوک'>
                                <svg width="32" height="32" viewBox="0 0 48 48" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg">

                                    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="Color-" transform="translate(-200.000000, -160.000000)" fill="#4460A0">
                                            <path
                                                d="M225.638355,208 L202.649232,208 C201.185673,208 200,206.813592 200,205.350603 L200,162.649211 C200,161.18585 201.185859,160 202.649232,160 L245.350955,160 C246.813955,160 248,161.18585 248,162.649211 L248,205.350603 C248,206.813778 246.813769,208 245.350955,208 L233.119305,208 L233.119305,189.411755 L239.358521,189.411755 L240.292755,182.167586 L233.119305,182.167586 L233.119305,177.542641 C233.119305,175.445287 233.701712,174.01601 236.70929,174.01601 L240.545311,174.014333 L240.545311,167.535091 C239.881886,167.446808 237.604784,167.24957 234.955552,167.24957 C229.424834,167.24957 225.638355,170.625526 225.638355,176.825209 L225.638355,182.167586 L219.383122,182.167586 L219.383122,189.411755 L225.638355,189.411755 L225.638355,208 L225.638355,208 Z"
                                                id="Facebook">

                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.twitter}>
                        <div>
                            <a href={info?.data?.social_networks?.twitter} target="_blank"
                               className="social-icon twitter"
                               title='توییتر'>
                                <svg width="32" height="32" viewBox="0 -4 48 48" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg">

                                    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="Color-" transform="translate(-300.000000, -164.000000)" fill="#00AAEC">
                                            <path
                                                d="M348,168.735283 C346.236309,169.538462 344.337383,170.081618 342.345483,170.324305 C344.379644,169.076201 345.940482,167.097147 346.675823,164.739617 C344.771263,165.895269 342.666667,166.736006 340.418384,167.18671 C338.626519,165.224991 336.065504,164 333.231203,164 C327.796443,164 323.387216,168.521488 323.387216,174.097508 C323.387216,174.88913 323.471738,175.657638 323.640782,176.397255 C315.456242,175.975442 308.201444,171.959552 303.341433,165.843265 C302.493397,167.339834 302.008804,169.076201 302.008804,170.925244 C302.008804,174.426869 303.747139,177.518238 306.389857,179.329722 C304.778306,179.280607 303.256911,178.821235 301.9271,178.070061 L301.9271,178.194294 C301.9271,183.08848 305.322064,187.17082 309.8299,188.095341 C309.004402,188.33225 308.133826,188.450704 307.235077,188.450704 C306.601162,188.450704 305.981335,188.390033 305.381229,188.271578 C306.634971,192.28169 310.269414,195.2026 314.580032,195.280607 C311.210424,197.99061 306.961789,199.605634 302.349709,199.605634 C301.555203,199.605634 300.769149,199.559408 300,199.466956 C304.358514,202.327194 309.53689,204 315.095615,204 C333.211481,204 343.114633,188.615385 343.114633,175.270495 C343.114633,174.831347 343.106181,174.392199 343.089276,173.961719 C345.013559,172.537378 346.684275,170.760563 348,168.735283"
                                                id="Twitter">

                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.youtube}>
                        <div>
                            <a href={info?.data?.social_networks?.youtube} target="_blank"
                               className="social-icon youtube"
                               title='یوتیوب'>
                                <svg width="32" height="32" viewBox="0 -7 48 48" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg">

                                    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="Color-" transform="translate(-200.000000, -368.000000)" fill="#CE1312">
                                            <path
                                                d="M219.044,391.269916 L219.0425,377.687742 L232.0115,384.502244 L219.044,391.269916 Z M247.52,375.334163 C247.52,375.334163 247.0505,372.003199 245.612,370.536366 C243.7865,368.610299 241.7405,368.601235 240.803,368.489448 C234.086,368 224.0105,368 224.0105,368 L223.9895,368 C223.9895,368 213.914,368 207.197,368.489448 C206.258,368.601235 204.2135,368.610299 202.3865,370.536366 C200.948,372.003199 200.48,375.334163 200.48,375.334163 C200.48,375.334163 200,379.246723 200,383.157773 L200,386.82561 C200,390.73817 200.48,394.64922 200.48,394.64922 C200.48,394.64922 200.948,397.980184 202.3865,399.447016 C204.2135,401.373084 206.612,401.312658 207.68,401.513574 C211.52,401.885191 224,402 224,402 C224,402 234.086,401.984894 240.803,401.495446 C241.7405,401.382148 243.7865,401.373084 245.612,399.447016 C247.0505,397.980184 247.52,394.64922 247.52,394.64922 C247.52,394.64922 248,390.73817 248,386.82561 L248,383.157773 C248,379.246723 247.52,375.334163 247.52,375.334163 L247.52,375.334163 Z"
                                                id="Youtube">

                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.aparat}>
                        <div>
                            <a href={info?.data?.social_networks?.aparat} target="_blank" className="social-icon aparat"
                               title='آپارات'>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="32" height="32">
                                    <path fill="#263238"
                                          d="M21.881 6.136l-4.315-.974c-3.52-.795-7.017 1.414-7.812 4.934l-.983 4.351C11.603 9.95 16.357 6.788 21.881 6.136zM6.136 26.119l-.974 4.315c-.795 3.52 1.414 7.017 4.934 7.812l4.351.983C9.95 36.396 6.788 31.643 6.136 26.119zM37.904 9.754l-4.351-.983c4.497 2.832 7.659 7.586 8.311 13.109l.974-4.315C43.633 14.047 41.424 10.549 37.904 9.754zM26.119 41.864l4.315.974c3.52.795 7.017-1.414 7.812-4.934l.983-4.351C36.397 38.05 31.643 41.212 26.119 41.864z"/>
                                    <path fill="#e91e63"
                                          d="M24,8C15.163,8,8,15.163,8,24s7.163,16,16,16s16-7.163,16-16S32.837,8,24,8z M20,13 c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4s-4-1.791-4-4C16,14.791,17.791,13,20,13z M17,32c-2.209,0-4-1.791-4-4 c0-2.209,1.791-4,4-4s4,1.791,4,4C21,30.209,19.209,32,17,32z M22,24c0-1.105,0.895-2,2-2s2,0.895,2,2c0,1.105-0.895,2-2,2 S22,25.105,22,24z M28,35c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C32,33.209,30.209,35,28,35z M31,24 c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C35,22.209,33.209,24,31,24z"/>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.eitaa}>
                        <div>
                            <a href={info?.data?.social_networks?.eitaa} target="_blank" className="social-icon eitaa"
                               title='ایتا'>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3584.55 3673.6" width="32"
                                     height="32">
                                    <g id="Isolation_Mode" data-name="Isolation Mode">
                                        <path
                                            d="M1071.43,2.75H2607.66C3171,2.75,3631.82,462.91,3631.82,1026.2v493.93c-505,227-1014.43,1348.12-1756.93,1104.51-61.16,43.46-202.11,222.55-212,358.43-257.11-34.24-553.52-328.88-517.95-646.62C717,2026.91,1070.39,1455.5,1409.74,1225.51c727.32-492.94,1737.05-69,1175.39,283.45-341.52,214.31-1071.84,355.88-995.91-170.24-200.34,57.78-328.58,431.34-87.37,626-223.45,219.53-180.49,623.07,58.36,755.57,241.56-625.87,1082.31-544.08,1422-1291.2,255.57-562-123.34-1202.37-880.91-1104C1529.56,399.34,993.64,881.63,725.62,1453.64,453.68,2034,494.15,2811.15,1052.55,3202.82c657.15,460.92,1356.78,34.13,1780.52-523.68,249.77-328.78,468-693,798.75-903.37v875.72c0,563.28-460.88,1024.86-1024.16,1024.86H1071.43c-563.29,0-1024.16-460.87-1024.16-1024.16V1026.9C47.27,463.61,508.14,2.74,1071.43,2.74Z"
                                            transform="translate(-47.27 -2.74)" fill="#ee7f22" fillRule="evenodd"/>
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.bale}>
                        <div>
                            <a href={info?.data?.social_networks?.bale} target="_blank" className="social-icon bale"
                               title='بله'>

                                <svg xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 1000 999.72" width="32" height="32">
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="800.4" y1="93.39" x2="93.57"
                                                        y2="800.23"
                                                        gradientUnits="userSpaceOnUse">
                                            <stop offset="0" stopColor="#4cebb4"></stop>
                                            <stop offset="1" stopColor="#2e2e74"></stop>
                                        </linearGradient>
                                    </defs>
                                    <g id="File">
                                        <g>
                                            <path
                                                d="M1010.36,547.36c-.73,17.77-2.6,36-6.85,53.41-1.54,16.48-6.36,32.54-10.76,48.52-5.14,19.5-12.48,38.33-19.9,57.17-6.77,15.66-14.35,30.91-22.26,46.08C942.92,766,934.93,779.2,926.29,792q-14.32,21-30.5,40.45c-11.18,13.13-22.68,26.09-35.15,37.92a503.68,503.68,0,0,1-51.3,43.55,453.44,453.44,0,0,1-48.44,31.56C742.06,956.74,722.16,966,702,974.6a548,548,0,0,1-65.89,21.86c-19.49,4.32-39,9.21-58.88,10.76-37,5.71-74.86,5.79-112.13,2.2-33.6-2.61-66.87-9.78-99.25-19.32l-.08-.58C210.19,944.18,82.32,816.07,34.94,661.2c-10.36-33.35-17.62-67.93-20.31-102.83-3.83-33.85-2-68-2.2-102q-.37-40.74-.08-81.64-.26-41.83,0-83.83c-.17-24-.08-47.95-.08-71.93s-.17-48.19.16-72.25c-.33-23.82-.08-47.63-.16-71.44-1.64-17.94,4.24-36.7,17.86-48.85C44.48,13.44,65.68,8.55,84,14.91c11.09,3.75,20.71,10.6,30.58,16.72,36,23.4,70.54,48.85,104.71,74.78a86.74,86.74,0,0,0,10.68-6.77A426.86,426.86,0,0,1,272.58,73.3a483.59,483.59,0,0,1,45.75-22.1c16.39-6.85,33.19-12.8,50.15-18.1,18.1-5,36.29-10.11,55-12.72a392.65,392.65,0,0,1,61.82-7.26,451.46,451.46,0,0,1,76.41,1.71A413.36,413.36,0,0,1,619,24c128.53,27,244.08,108.3,314.46,219a493,493,0,0,1,66.47,159.76c4.73,20.95,8.48,42.32,9.7,63.77A411.89,411.89,0,0,1,1010.36,547.36Z"
                                                transform="translate(-12 -12.14)" fill="url(#linear-gradient)"></path>
                                            <path
                                                d="M705.69,273.2a107.59,107.59,0,0,1,62.37,1.3c25.62,9.82,46.29,29.94,57.5,54.9,8.34,22.86,9.31,48.42.91,71.44-6.06,16.2-16.76,30.09-29.4,41.74q-16.7,16.49-33.21,33.14c-11.79,11.79-23.64,23.5-35.33,35.35-11.3,11.28-22.62,22.49-33.85,33.81-12.32,12.34-24.68,24.61-36.95,37-14,14-28.06,27.94-42,42-13.24,13.29-26.55,26.49-39.8,39.78s-26.77,26.71-40.1,40.11c-12.27,11.85-23.51,24.94-37.35,35.06a106.69,106.69,0,0,1-57.95,16C417,753.28,393.79,744,376.87,727.33q-78.53-78.44-157-156.94c-12.82-12.66-21.38-29.07-26-46.38-4.75-23.86-1.94-49.51,10.31-70.75,9.37-16.54,23.79-29.65,40.19-39a107.52,107.52,0,0,1,57.86-9.73c21.38,3.21,42,13,56.91,28.76Q401.7,476,444.37,518.5c8.63-8.18,16.9-16.73,25.19-25.27q18-17.31,35.24-35.35c11.36-10.68,22.33-21.82,33.07-33.12,7.74-6.88,14.75-14.51,22.07-21.8,12-11.68,23.75-23.59,35.49-35.51,11.21-10.83,22.11-21.95,33.07-33,11.79-11.5,23.28-23.28,35-34.87a105.75,105.75,0,0,1,42.21-26.37Z"
                                                transform="translate(-12 -12.14)" fill="#fff"></path>
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.rubika}>
                        <div>
                            <a href={info?.data?.social_networks?.rubika} target="_blank" className="social-icon rubika"
                               title='روبیکا'>

                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 495.37 543.04" width="32" height="32">
                                    <path
                                        d="M246.07,0h1.76c.48,42.73-.25,128.44-.25,128.44-40.86-22.92-82-45.3-122.84-68.29q40.13-22.81,80.32-45.51c12.69-7.16,26.33-13.31,41-14.64Z"
                                        fill="#b8ce01"/>
                                    <path
                                        d="M247.73,0h3C266.62,1.43,281,9,294.67,16.68Q332.91,38.25,371.05,60c-41,22.73-82.45,45.82-123.51,68.48-.35-42.73.63-85.77.15-128.5Z"
                                        fill="#7db425"/>
                                    <path
                                        d="M124.77,60.11,247.61,128.4,123.92,200.66s-.06-45.85.08-68.71C123.89,108.21,124.77,60.11,124.77,60.11Z"
                                        fill="#f6a925"/>
                                    <path
                                        d="M371.19,60l.35.19c-.1,42.59,0,85.18,0,127.77-.07,4.17-.11,12.77-.11,12.77L247.62,128.45S330.2,82.76,371.23,60Z"
                                        fill="#35ac9d"/>
                                    <path
                                        d="M371.44,60.21c27.28,15.51,54.37,31.36,81.47,47.17,13.11,7.36,27,15.52,34.16,29.39-38.38,21.25-115.68,64-115.68,64s-.06-8.61,0-12.78q0-63.89,0-127.77Z"
                                        fill="#59d6bd"/>
                                    <path
                                        d="M46.5,105c25.65-15,78.19-44.88,78.19-44.88L124,200.66S47,158.21,8.71,137C17.05,122.13,32.11,113.12,46.5,105Z"
                                        fill="#ef7414"/>
                                    <path
                                        d="M247.5,128.44l123.81,72.3s-39.84,22-59.62,32.64c-21.14,12-64.09,35.82-64.09,35.82L123.94,200.66Z"
                                        fill="#fff"/>
                                    <path
                                        d="M0,193C.11,174.17-.23,154.15,8.66,137,47,158.21,123.92,200.66,123.92,200.66,82.55,224.58,41.38,248.86,0,272.81,0,246.21,0,219.62,0,193Z"
                                        fill="#e74b50"/>
                                    <path
                                        d="M487.07,136.77c7.54,14.1,8.64,30.5,8.22,46.19v90.11L371.41,200.76S448.69,158,487.07,136.77Z"
                                        fill="#794387"/>
                                    <path
                                        d="M123.92,200.66c.19-.08,123.66,68.54,123.66,68.54s0,71.69.07,106.76c.2,11.29-.07,34.11-.07,34.11-41.27-22.78-82.32-45.76-123.6-68.54l-.07-.31V200.66Z"
                                        fill="#e4e4e4"/>
                                    <path
                                        d="M0,272.81c41.35-24,82.52-48.23,123.89-72.15q-.06,70.29,0,140.56c-6.35-2.65-12.13-6.43-18.19-9.64C70.5,312.21,35.38,292.39,0,273.21v-.4Z"
                                        fill="#794387"/>
                                    <path
                                        d="M371.39,200.76v86.18c-.13,18.27.46,36.47,0,54.73-41.21,22.4-123.82,68.4-123.82,68.4s.27-22.82.07-34.11c0-35.07-.07-106.76-.07-106.76Z"
                                        fill="#f1f1f1"/>
                                    <path
                                        d="M371.39,200.76s123.88,72.14,123.88,72.31c-41.17,22.82-123.87,68.6-123.87,68.6h0c.46-18.26-.13-36.46,0-54.73V200.76Z"
                                        fill="#4c3683"/>
                                    <path
                                        d="M0,273.21c35.36,19.21,70.43,39,105.7,58.4,6.06,3.21,11.84,7,18.19,9.64l.07.31Q67,374.79,10,408.05C6,402,4,394.86,2.53,387.8.14,376,0,364,0,352v-78.8Z"
                                        fill="#4c3683"/>
                                    <path
                                        d="M495.27,273.07c.06,27.65,0,55.3,0,82.95.4,17.73-.12,36.62-9.57,52.25-34.2-20-114.33-66.6-114.33-66.6S454.1,295.89,495.27,273.07Z"
                                        fill="#e74b50"/>
                                    <path
                                        d="M10,408Q67,374.72,124,341.53c-.25,46.83.08,93.67-.16,140.49q-40.35-22.75-80.49-45.86C30.82,428.76,18,420.53,10,408Z"
                                        fill="#0f68a0"/>
                                    <path
                                        d="M124,341.53c41.28,22.78,82.33,45.76,123.6,68.54-41.2,24-123.7,72-123.76,71.95.24-46.82-.09-93.66.16-140.49Z"
                                        fill="#49bdca"/>
                                    <path
                                        d="M371.2,341.76l.2-.09c.12,46.84-.25,93.69.19,140.53l-.31.15c-32.66-19.51-65.71-38.4-98.52-57.68-8.26-4.7-25.18-14.6-25.18-14.6S330,364.21,371.2,341.76Z"
                                        fill="#f6a925"/>
                                    <path
                                        d="M371.4,341.67h0c3.65,2.49,80.13,46.62,114.33,66.6-4.86,8.3-12.56,14.39-20.32,19.84-12.52,8.42-25.88,15.47-38.9,23.05-18.31,10.35-36.5,20.91-54.92,31-.44-46.84-.07-93.69-.19-140.53Z"
                                        fill="#ef7414"/>
                                    <path
                                        d="M247.58,410.07V543c-10.25-1.51-21.42-3.87-30.5-9.08C186,516.66,154.81,499.5,123.82,482,165,458,206.38,434.12,247.58,410.07Z"
                                        fill="#7db425"/>
                                    <path
                                        d="M247.58,410.07s16.92,9.9,25.18,14.6c32.81,19.28,65.86,38.17,98.52,57.68q-47.79,26.44-95.57,53A62.47,62.47,0,0,1,249.84,543h-2.26Z"
                                        fill="#b8ce01"/>
                                    <path d="M602.83,233.66" fill="#f1f1f1"/>
                                </svg>
                            </a>
                        </div>
                    </RenderIf>


                    <RenderIf condition={info?.data?.social_networks?.igap}>
                        <div>
                            <a href={info?.data?.social_networks?.igap} target="_blank" className="social-icon igap"
                               title='آی‌گپ'>
                                <img src={'/images/social/igap.png'} width={32} height={32} alt={'igap'}/>
                            </a>
                        </div>
                    </RenderIf>


                    <RenderIf condition={info?.data?.social_networks?.nasimRezvan}>
                        <div>
                            <a href={info?.data?.social_networks?.nasimRezvan} target="_blank"
                               className="social-icon nasim-rezvan"
                               title='نسیم رضوان'>
                                <img src={'/images/social/nasim-rezvan.png'} width={32} height={32} alt={'nasim'}/>
                            </a>
                        </div>
                    </RenderIf>

                    <RenderIf condition={info?.data?.social_networks?.gap}>
                        <div>
                            <a href={info?.data?.social_networks?.gap} target="_blank" className="social-icon gap"
                               title='گپ'>
                                <img src={'/images/social/gap.png'} width={32} height={32} alt={'gap'}/>
                            </a>
                        </div>

                    </RenderIf>


                    <RenderIf condition={info?.data?.social_networks?.telegram}>
                        <div>

                            <a href={info?.data?.social_networks?.telegram} target="_blank"
                               className="social-icon telegram"
                               title='تلگرام'>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_87_7225)"/>
                                    <path
                                        d="M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z"
                                        fill="white"/>
                                    <defs>
                                        <linearGradient id="paint0_linear_87_7225" x1="16" y1="2" x2="16" y2="30"
                                                        gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#37BBFE"/>
                                            <stop offset="1" stopColor="#007DBB"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </a>

                        </div>
                    </RenderIf>
                </div>
            </div>

            <RenderIf condition={info?.data?.enamad?.code && info?.data?.enamad?.number}>
                <div className={'mt-4 flex flex-wrap gap-2 justify-center items-center max-w-md'}>
                    <span className={'cursor-pointer'}>
                    <a referrerPolicy="origin" target="_blank"
                       href={`https://trustseal.enamad.ir/?id=${info?.data?.enamad?.number}&amp;Code=${info?.data?.enamad?.code}`}>
                        <img
                            referrerPolicy="origin"
                            src={`https://Trustseal.eNamad.ir/logo.aspx?id=${info?.data?.enamad?.number}&amp;Code=${info?.data?.enamad?.code}`}
                            alt="enamd"
                            id={info?.data?.enamad?.code}/>
                    </a>
                    </span>
                </div>
            </RenderIf>

            <ContactInfo data={info}/>

        </div>
    );
}

export default AuthSocialNetworkSection;

function ContactInfo({data}) {
    return (
        <RenderIf condition={data?.data?.website ||
            data?.data?.phone ||
            data?.data?.address ||
            data?.data?.description}>
            <div className="rounded-2xl shadow-xl p-6 w-full bg-transparent dark:bg-slate-900/40">

                <div className="space-y-4">
                    <h3 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-4 text-right">
                        اطلاعات تماس
                    </h3>

                    {data?.data?.website && (
                        <div className="flex items-start gap-3 text-right" dir="rtl">
                            <div className="p-2 bg-teal-50 dark:bg-teal-950/40 rounded-lg">
                                <Globe className="text-teal-600 dark:text-teal-400" size={20}/>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm text-slate-500 dark:text-slate-400 mb-1">وبسایت</p>
                                <a
                                    href={data?.data?.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-slate-700 dark:text-slate-200 hover:text-teal-600 dark:hover:text-teal-400 transition-colors font-medium break-all"
                                >
                                    {data?.data?.website}
                                </a>
                            </div>
                        </div>
                    )}

                    {data?.data?.phone && (
                        <div className="flex items-start gap-3 text-right" dir="rtl">
                            <div className="p-2 bg-teal-50 dark:bg-teal-950/40 rounded-lg">
                                <Phone className="text-teal-600 dark:text-teal-400" size={20}/>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm text-slate-500 dark:text-slate-400 mb-1">تلفن تماس</p>
                                <a
                                    href={`tel:${data?.data?.phone}`}
                                    className="text-slate-700 dark:text-slate-200 hover:text-teal-600 dark:hover:text-teal-400 transition-colors font-medium"
                                    dir="ltr"
                                >
                                    {data?.data?.phone}
                                </a>
                            </div>
                        </div>
                    )}

                    {data?.data?.address && (
                        <div className="flex items-start gap-3 text-right" dir="rtl">
                            <div className="p-2 bg-teal-50 dark:bg-teal-950/40 rounded-lg">
                                <MapPin className="text-teal-600 dark:text-teal-400" size={20}/>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm text-slate-500 dark:text-slate-400 mb-1">آدرس</p>
                                <p className="text-slate-700 dark:text-slate-200 leading-relaxed">
                                    {data?.data?.address}
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                <RenderIf condition={false}>
                    {/* Description at Bottom */}
                    {data?.data?.description && (
                        <div className="mt-6 pt-6 border-t border-slate-200 dark:border-slate-700">
                            <div
                                className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-950/30 dark:to-orange-950/30 rounded-lg p-4 text-right"
                                dir="rtl"
                            >
                                <p className="text-slate-700 dark:text-slate-300 leading-relaxed whitespace-pre-line text-sm">
                                    {data?.data?.description}
                                </p>
                            </div>
                        </div>
                    )}
                </RenderIf>
            </div>
        </RenderIf>
    );
}